var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9708 0.483887C6.60555 0.483887 1.44568 5.64376 1.44568 12.009C1.44568 18.3742 6.60555 23.534 12.9708 23.534C19.336 23.534 24.4958 18.3742 24.4958 12.009C24.4958 5.64376 19.336 0.483887 12.9708 0.483887ZM10.1495 16.7859H7.81568V9.27536H10.1495V16.7859ZM8.96819 8.35335C8.23107 8.35335 7.75446 7.83112 7.75446 7.18524C7.75446 6.52615 8.24547 6.01952 8.9982 6.01952C9.75094 6.01952 10.2119 6.52615 10.2263 7.18524C10.2263 7.83112 9.75094 8.35335 8.96819 8.35335ZM18.6733 16.7859H16.3394V12.6236C16.3394 11.6548 16.0009 10.9969 15.1569 10.9969C14.5122 10.9969 14.1293 11.4423 13.96 11.8709C13.8976 12.0234 13.882 12.2395 13.882 12.4544V16.7847H11.5469V11.6704C11.5469 10.7328 11.5169 9.94885 11.4857 9.27416H13.5134L13.6202 10.3174H13.6671C13.9744 9.8276 14.7271 9.10488 15.9865 9.10488C17.522 9.10488 18.6733 10.1337 18.6733 12.3451V16.7859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0106,
    height: 24.0106,
    fill: "white",
    transform: "translate(0.964722 0.00341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f14bb828a562264eac68ab868bf9064e.svg";
export { ForwardRef as ReactComponent };